/* ============================================================
   BLINK & BLISS - theme.js (vanilla, no dependencies)
   Config and every shopper-visible string come from window.BBTheme
   (layout/theme.liquid). Nothing here prints hardcoded copy.
   ============================================================ */
(function(){
  "use strict";
  var T = window.BBTheme = window.BBTheme || {};
  // Safety net: if the inline config ever fails to render, keep the cart working with standard routes.
  T.routes = T.routes || {};
  T.routes.cart_add = T.routes.cart_add || "/cart/add";
  T.routes.cart_change = T.routes.cart_change || "/cart/change";
  T.routes.cart = T.routes.cart || "/cart";
  T.routes.checkout = T.routes.checkout || "/checkout";
  T.strings = T.strings || {};
  if(T.cart_type !== "page") T.cart_type = "drawer";
  T.free_bar = T.free_bar === true;
  if(typeof T.free_threshold !== "number" || !(T.free_threshold > 0)) T.free_threshold = 0;
  if(typeof T.money_format !== "string" || T.money_format.indexOf("amount") < 0) T.money_format = "${{amount}}";
  var $ = function(s, c){ return (c||document).querySelector(s); };
  var $$ = function(s, c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };
  function S(key){ var v = T.strings[key]; return (typeof v === "string") ? v : ""; }
  // Replace [token] placeholders; values are inserted literally (no "$" replacement patterns).
  function fill(str, map){
    return String(str || "").replace(/\[(\w+)\]/g, function(m, k){ return Object.prototype.hasOwnProperty.call(map, k) ? String(map[k]) : m; });
  }

  /* ---------- Money (all Shopify money_format placeholders) ---------- */
  function formatMoney(cents){
    var n = Number(cents); if(isNaN(n)) n = 0;
    var neg = n < 0; n = Math.abs(n) / 100;
    function fmt(decimals, thousands, decimal){
      var parts = n.toFixed(decimals).split(".");
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return whole + (parts[1] ? decimal + parts[1] : "");
    }
    var out = T.money_format.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, name){
      switch(name){
        case "amount": return fmt(2, ",", ".");
        case "amount_no_decimals": return fmt(0, ",", ".");
        case "amount_with_comma_separator": return fmt(2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return fmt(0, ".", ",");
        case "amount_with_apostrophe_separator": return fmt(2, "'", ".");
        case "amount_no_decimals_with_space_separator": return fmt(0, " ", ",");
        case "amount_with_space_separator": return fmt(2, " ", ",");
        case "amount_with_period_and_space_separator": return fmt(2, " ", ".");
        default: return fmt(2, ",", ".");
      }
    });
    return (neg ? "-" : "") + out;
  }
  window.BBformatMoney = formatMoney;

  /* ---------- Reveal animations ---------- */
  function initReveal(){
    if(!document.body.classList.contains("anim-on")) return;
    var els = $$(".reveal:not(.in), .stagger:not(.in)");
    if(!("IntersectionObserver" in window) || !els.length){ els.forEach(function(e){ e.classList.add("in"); }); return; }
    // Anything within the first screen and a half is shown immediately (ad landers: no waiting for a scroll).
    var vh = window.innerHeight || 800, pending = [];
    els.forEach(function(e){
      var top = e.getBoundingClientRect().top;
      if(top < vh * 1.5){ e.classList.add("in"); } else { pending.push(e); }
    });
    if(!pending.length) return;
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold:.12, rootMargin:"0px 0px -7% 0px" });
    pending.forEach(function(e){ io.observe(e); });
    // safety net: never leave content invisible for long
    setTimeout(function(){ pending.forEach(function(e){ if(e.getBoundingClientRect().top < vh * 1.5) e.classList.add("in"); }); }, 1500);
  }

  /* ---------- Step comparison: tap-to-compare tabs on mobile (labels come from the section's own column tags) ---------- */
  function initCompareTabs(){
    $$("[data-compare-grid] .compare-card").forEach(function(card){
      if(card.dataset.tabbed) return; card.dataset.tabbed = "1";
      var cols = card.querySelector(".compare-card__cols"); if(!cols) return;
      var usual = card.querySelector(".compare-col--usual"), ours = card.querySelector(".compare-col--ritual");
      if(!usual || !ours) return;
      var ut = usual.querySelector(".compare-col__tag"), rt = ours.querySelector(".compare-col__tag");
      if(!ut || !rt || !ut.textContent || !rt.textContent) return;
      var tabs = document.createElement("div"); tabs.className = "compare-tabs"; tabs.setAttribute("role", "tablist");
      var bu = document.createElement("button"); bu.type = "button"; bu.className = "compare-tab"; bu.setAttribute("role", "tab");
      var br = document.createElement("button"); br.type = "button"; br.className = "compare-tab"; br.setAttribute("role", "tab");
      bu.textContent = ut.textContent;
      br.textContent = rt.textContent;
      function setTab(which){
        card.classList.toggle("show-usual", which === "usual");
        bu.classList.toggle("is-active", which === "usual");
        br.classList.toggle("is-active", which !== "usual");
        bu.setAttribute("aria-selected", which === "usual" ? "true" : "false");
        br.setAttribute("aria-selected", which === "usual" ? "false" : "true");
      }
      bu.addEventListener("click", function(){ setTab("usual"); });
      br.addEventListener("click", function(){ setTab("ours"); });
      tabs.appendChild(bu); tabs.appendChild(br);
      cols.parentNode.insertBefore(tabs, cols);
      setTab("ours");
    });
  }

  /* ---------- Step comparison: videos. Play when visible (autoplay can be blocked in
     Low Power Mode / data saver; if play() is refused, hand the shopper the controls). ---------- */
  function initCompareVideos(){
    var vids = $$(".compare-card__media video");
    if(!vids.length) return;
    function tryPlay(v){
      var p; try{ p = v.play(); }catch(err){ v.controls = true; return; }
      if(p && p.catch){ p.catch(function(){ v.controls = true; }); }
    }
    if(!("IntersectionObserver" in window)){ vids.forEach(tryPlay); return; }
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(e){
        if(e.isIntersecting){ tryPlay(e.target); } else if(!e.target.paused){ e.target.pause(); }
      });
    }, { threshold:.35 });
    vids.forEach(function(v){ io.observe(v); });
  }

  /* ---------- Header scroll ---------- */
  function initHeader(){
    var h = $(".header"); if(!h) return;
    var on = function(){ h.classList.toggle("scrolled", window.scrollY > 12); };
    on(); window.addEventListener("scroll", on, { passive:true });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu(){
    var menu = $("#MobileMenu");
    document.addEventListener("click", function(e){
      if(!e.target.closest) return;
      if(e.target.closest("[data-menu-open]")){ menu && menu.classList.add("show"); document.body.style.overflow="hidden"; }
      if(e.target.closest("[data-menu-close]") || (menu && e.target === menu)){ menu && menu.classList.remove("show"); document.body.style.overflow=""; }
    });
  }

  /* ---------- Small shared helpers ---------- */
  function setBusy(el, on){
    if(!el) return;
    el.classList.toggle("is-loading", !!on);
    if(on){ el.setAttribute("aria-busy", "true"); } else { el.removeAttribute("aria-busy"); }
  }
  // POST to the Cart API. Resolves with the parsed JSON; rejects with { description } taken from Shopify's error body.
  function cartPost(url, body, isJson){
    var headers = { "Accept":"application/json", "X-Requested-With":"XMLHttpRequest" };
    if(isJson){ headers["Content-Type"] = "application/json"; body = JSON.stringify(body); }
    return fetch(url, { method:"POST", headers:headers, body:body, credentials:"same-origin" }).then(function(r){
      return r.json().catch(function(){ return null; }).then(function(j){
        var failed = !r.ok || (j && typeof j.status === "number" && j.status >= 400);
        if(failed){
          var d = j && (j.description || j.message);
          var err = new Error(typeof d === "string" ? d : "cart request failed");
          err.description = (typeof d === "string") ? d : "";
          throw err;
        }
        return j;
      });
    });
  }
  // Inline add-to-cart error next to a form / button (role="alert"). Pass "" to clear.
  function errorBox(scope, anchor){
    if(!scope) return null;
    var box = scope.querySelector("[data-atc-error]");
    if(!box && scope.parentNode && scope.tagName === "FORM"){ box = scope.parentNode.querySelector("[data-atc-error]"); }
    if(!box){
      box = document.createElement("p");
      box.className = "atc-error"; box.setAttribute("data-atc-error", ""); box.setAttribute("role", "alert"); box.hidden = true;
      if(anchor && anchor.parentNode && scope.contains(anchor)){ anchor.parentNode.insertBefore(box, anchor.nextSibling); }
      else { scope.appendChild(box); }
    }
    return box;
  }
  function showError(scope, anchor, msg){
    var box = errorBox(scope, anchor); if(!box) return;
    box.textContent = msg || "";
    box.hidden = !msg;
    if(msg && box.getBoundingClientRect){
      var r = box.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight;
      if((r.top < 0 || r.bottom > vh) && box.scrollIntoView){ try{ box.scrollIntoView({ behavior:"smooth", block:"center" }); }catch(err){ box.scrollIntoView(); } }
    }
  }
  function clearError(scope){
    if(!scope) return;
    var box = scope.querySelector("[data-atc-error]");
    if(!box && scope.parentNode && scope.tagName === "FORM"){ box = scope.parentNode.querySelector("[data-atc-error]"); }
    if(box){ box.textContent = ""; box.hidden = true; }
  }

  /* ---------- Cart ---------- */
  var drawer = { el:null, scrim:null, lastFocus:null };
  var expressReq = 0;
  function cartPageEl(){ return $("[data-cart-page]"); }
  function isOpen(){ return !!(drawer.el && drawer.el.classList.contains("show")); }
  function drawerFocusables(){
    if(!drawer.el) return [];
    return $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', drawer.el)
      .filter(function(el){ return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; });
  }
  function openCart(){
    if(cartPageEl()) return;                       // already looking at the cart
    if(T.cart_type === "page" || !drawer.el){ window.location.href = T.routes.cart; return; }
    if(isOpen()) return;
    drawer.lastFocus = document.activeElement;
    drawer.el.removeAttribute("inert");
    drawer.el.setAttribute("aria-hidden", "false");
    drawer.el.classList.add("show");
    drawer.scrim && drawer.scrim.classList.add("show");
    document.body.style.overflow = "hidden";
    var closeBtn = $("[data-cart-close]", drawer.el);
    try{ (closeBtn || drawer.el).focus({ preventScroll:true }); }catch(err){}
  }
  function closeCart(){
    if(!drawer.el || !isOpen()) return;
    drawer.el.classList.remove("show");
    drawer.el.setAttribute("aria-hidden", "true");
    drawer.el.setAttribute("inert", "");
    drawer.scrim && drawer.scrim.classList.remove("show");
    document.body.style.overflow = "";
    var back = drawer.lastFocus; drawer.lastFocus = null;
    if(back && back.focus && document.contains(back)){ try{ back.focus({ preventScroll:true }); }catch(err){} }
  }
  function cartError(msg){
    var box = $("#CartError"); if(!box) return;
    box.textContent = msg || ""; box.hidden = !msg;
  }

  // Threshold is entered in the store currency; convert for the shopper's currency when Markets is converting.
  function freeThreshold(cart){
    var th = T.free_threshold;
    if(th > 0 && T.shop_currency && cart && cart.currency && cart.currency !== T.shop_currency){
      var rate = window.Shopify && window.Shopify.currency ? parseFloat(window.Shopify.currency.rate) : NaN;
      if(rate > 0) th = Math.round(th * rate);
    }
    return th;
  }
  function renderShipBar(cart){
    var bar = $("#ShipBar"); if(!bar) return;
    if(!T.free_bar || !cart.item_count){ bar.style.display = "none"; return; }
    bar.style.display = "";
    var txt = $("#ShipBarTxt"), fillEl = $("#ShipBarFill");
    var th = freeThreshold(cart);
    var check = '<span class="ship-bar__check" aria-hidden="true"></span>';
    var remain = th > 0 ? Math.max(0, th - cart.total_price) : 0;
    var html = "";
    if(th <= 0){ if(S("free_ship_every")) html = check + "<b>" + escapeHtml(S("free_ship_every")) + "</b>"; }
    else if(remain > 0){ html = fill(escapeHtml(S("free_ship_remaining")), { amount: "<b>" + escapeHtml(formatMoney(remain)) + "</b>" }); }
    else if(S("free_ship_unlocked")){ html = check + "<b>" + escapeHtml(S("free_ship_unlocked")) + "</b>"; }
    if(txt && html) txt.innerHTML = html;
    if(fillEl) fillEl.style.width = (th > 0 ? Math.min(100, (cart.total_price / th) * 100) : 100) + "%";
    bar.classList.toggle("is-unlocked", remain <= 0);
  }

  function lineHtml(it){
    var name = it.product_title || it.title || "";
    var src = it.image || (it.featured_image && it.featured_image.url) || "";
    var img = src ? '<img src="' + escapeHtml(src + (src.indexOf("?") > -1 ? "&" : "?") + "width=160") + '" alt="' + escapeHtml(name) + '" loading="lazy" width="80" height="80">' : "";
    var meta = (it.options_with_values || []).filter(function(o){ return o && o.value && o.value !== "Default Title"; }).map(function(o){ return o.value; }).join(" / ");
    var extra = "";
    if(meta) extra += '<div class="cart-line__meta">' + escapeHtml(meta) + '</div>';
    var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.name;
    if(plan) extra += '<div class="cart-line__meta cart-line__plan">' + escapeHtml(plan) + '</div>';
    var props = it.properties;
    if(props && typeof props === "object"){
      Object.keys(props).forEach(function(k){
        var v = props[k];
        if(!k || k.charAt(0) === "_" || v === null || typeof v === "undefined") return;
        v = String(v); if(!v.replace(/\s+/g, "")) return;
        extra += '<div class="cart-line__meta cart-line__prop"><span class="cart-line__prop-k">' + escapeHtml(k) + ':</span> ' + escapeHtml(v) + '</div>';
      });
    }
    (it.line_level_discount_allocations || []).forEach(function(a){
      var title = a && a.discount_application && a.discount_application.title;
      if(!title) return;
      var amt = Number(a.amount) > 0 ? ' <span class="cart-line__disc-amt">(&minus;' + escapeHtml(formatMoney(a.amount)) + ')</span>' : "";
      extra += '<div class="cart-line__meta cart-line__disc">' + escapeHtml(title) + amt + '</div>';
    });
    var compare = (it.original_line_price > it.final_line_price) ? '<s>' + escapeHtml(formatMoney(it.original_line_price)) + '</s>' : "";
    return '<div class="cart-line" data-key="' + escapeHtml(it.key) + '">' +
      '<a class="cart-line__media" href="' + escapeHtml(it.url || "#") + '">' + img + '</a>' +
      '<div class="cart-line__body" style="flex:1;min-width:0">' +
        '<a class="cart-line__name" href="' + escapeHtml(it.url || "#") + '">' + escapeHtml(name) + '</a>' +
        extra +
        '<div class="cart-line__bottom">' +
          '<div class="qty" role="group" aria-label="' + escapeHtml(S("quantity")) + '"><button type="button" data-qty-down aria-label="' + escapeHtml(S("decrease")) + '">' + icon("minus") + '</button><span>' + it.quantity + '</span><button type="button" data-qty-up aria-label="' + escapeHtml(S("increase")) + '">' + icon("plus") + '</button></div>' +
          '<div class="price"><b>' + escapeHtml(formatMoney(it.final_line_price)) + '</b>' + compare + '</div>' +
        '</div>' +
        '<button type="button" class="cart-line__rm" data-remove>' + escapeHtml(S("remove")) + '</button>' +
      '</div></div>';
  }

  function renderCart(cart){
    if(!cart || !Array.isArray(cart.items)){ return; }
    var count = cart.item_count;
    $$(".cart-count").forEach(function(c){ c.textContent = count; c.style.display = count > 0 ? "" : "none"; });
    renderShipBar(cart);
    var body = $("#CartBody"); if(!body) return;
    var foot = $("#CartFoot");
    var upsellWrap = $("#CartUpsell");
    if(count === 0){
      var shopUrl = T.routes.shop || "";
      var cta = S("empty_cta") ? (shopUrl
        ? '<a class="btn btn--accent" href="' + escapeHtml(shopUrl) + '" data-cart-shop>' + escapeHtml(S("empty_cta")) + '</a>'
        : '<button type="button" class="btn btn--accent" data-cart-close>' + escapeHtml(S("empty_cta")) + '</button>') : "";
      body.innerHTML = '<div class="cart-empty">' + icon("bag") +
        '<div>' + (S("empty_title") ? '<div class="serif cart-empty__title" style="font-size:24px;margin-bottom:6px">' + escapeHtml(S("empty_title")) + '</div>' : "") +
        (S("empty_text") ? '<p class="cart-empty__text" style="font-size:14px;max-width:30ch;margin:0 auto">' + escapeHtml(S("empty_text")) + '</p>' : "") + '</div>' +
        cta + '</div>';
      if(foot) foot.style.display = "none";
      var exEmpty = $("#CartExpress"); if(exEmpty){ expressReq++; exEmpty.innerHTML = ""; exEmpty.removeAttribute("data-express-sig"); }
      if(upsellWrap){
        var any = 0;
        $$("[data-upsell-product]", upsellWrap).forEach(function(u){ u.style.display = ""; any++; });
        upsellWrap.style.display = any > 0 ? "" : "none";
      }
      return;
    }
    if(foot) foot.style.display = "";
    if(T.cart_type !== "page") refreshExpress(cart);
    body.innerHTML = cart.items.map(lineHtml).join("");

    // cart-level discounts + total savings
    var discWrap = $("#CartDiscounts");
    if(discWrap){
      discWrap.innerHTML = (cart.cart_level_discount_applications || []).map(function(d){
        if(!d || !d.title) return "";
        var amt = Number(d.total_allocated_amount) > 0 ? '<span class="cart-disc__amt">&minus;' + escapeHtml(formatMoney(d.total_allocated_amount)) + '</span>' : "";
        return '<div class="cart-disc"><span class="cart-disc__title">' + escapeHtml(d.title) + '</span>' + amt + '</div>';
      }).join("");
      discWrap.hidden = !discWrap.innerHTML;
    }
    var save = $("#CartSavings");
    if(save){
      var saved = Number(cart.total_discount) || 0;
      var saveAmt = $("[data-cart-savings]", save);
      if(saveAmt) saveAmt.textContent = formatMoney(saved);
      save.hidden = !(saved > 0);
    }
    var sub = $("#CartSubtotal"); if(sub) sub.textContent = formatMoney(cart.total_price);
    var checkout = $("#CartCheckout");
    if(checkout && S("checkout")) checkout.textContent = S("checkout") + " · " + formatMoney(cart.total_price);

    // hide upsells already in cart; hide the whole block when nothing is left to offer
    if(upsellWrap){
      var ids = cart.items.map(function(i){ return i.product_id; }), visible = 0;
      $$("[data-upsell-product]", upsellWrap).forEach(function(u){
        var hide = ids.indexOf(parseInt(u.getAttribute("data-upsell-product"), 10)) > -1;
        u.style.display = hide ? "none" : ""; if(!hide) visible++;
      });
      upsellWrap.style.display = visible > 0 ? "" : "none";
    }
  }

  function fetchCart(){
    return fetch(T.routes.cart + ".js", { headers:{ "Accept":"application/json" }, credentials:"same-origin" }).then(function(r){ if(!r.ok) throw new Error("cart fetch failed"); return r.json(); });
  }
  // Read-only refresh (initial load, external "cart:refresh"). Does not announce or dispatch.
  function refreshCart(){
    return fetchCart().then(function(cart){ renderCart(cart); return cart; });
  }
  // The server-rendered cart page cannot be patched in place: reload it when the cart no longer matches.
  function syncCartPage(cart){
    var page = cartPageEl(); if(!page || !cart) return false;
    var same = String(cart.item_count) === page.getAttribute("data-cart-count") && String(cart.total_price) === page.getAttribute("data-cart-total");
    if(!same){ window.location.reload(); return true; }
    return false;
  }
  // After every mutation: re-render, announce to assistive tech, tell other scripts.
  function commitCart(cart){
    if(!cart || !Array.isArray(cart.items)) return cart;
    renderCart(cart);
    cartError("");
    var live = $("#CartLive");
    if(live && S("cart_updated")){ live.textContent = fill(S("cart_updated"), { count: cart.item_count, total: formatMoney(cart.total_price) }); }
    try{ document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart })); }catch(err){}
    syncCartPage(cart);
    return cart;
  }
  function mutated(){ return fetchCart().then(commitCart); }
  // Add paths only: the add itself succeeded, so a failed follow-up /cart.js read must not read as "could not add"
  // (the drawer still opens, with the cart error line; the next refresh clears it).
  function afterAdd(){
    return mutated().catch(function(){
      cartError(S("cart_error"));
      $$(".cart-line.is-updating").forEach(function(l){ l.classList.remove("is-updating"); });
      return null;
    });
  }
  // Cart mutations run one at a time so responses commit in request order; a slow earlier
  // response can never overwrite a later one (two lines changed back to back, or a drawer quick-add).
  var cartQueue = Promise.resolve();
  function enqueue(fn){ var p = cartQueue.then(fn, fn); cartQueue = p.catch(function(){}); return p; }

  /* ---------- Cart-level express checkout (real Apple Pay / Google Pay / Shop Pay / PayPal for the WHOLE cart, bundles included).
     Shopify renders these in sections/cart-express.liquid; we fetch that section through the Section Rendering API
     whenever the cart changes and mount it in the drawer footer. Skipped when the cart contents did not change. ---------- */
  var expressScriptSrcs = {};
  function runInjectedScripts(scope){
    // Scripts assigned via innerHTML never execute; recreate each one so the wallet
    // bootstrap actually runs. External srcs load once, inline bootstraps re-run per mount.
    $$("script", scope).forEach(function(old){
      var src = old.getAttribute("src");
      if(src){
        if(expressScriptSrcs[src]){ if(old.parentNode){ old.parentNode.removeChild(old); } return; }
        expressScriptSrcs[src] = 1;
      }
      var s = document.createElement("script");
      for(var i = 0; i < old.attributes.length; i++){ s.setAttribute(old.attributes[i].name, old.attributes[i].value); }
      s.text = old.text || "";
      if(old.parentNode) old.parentNode.replaceChild(s, old);
    });
  }
  function refreshExpress(cart){
    var wrap = $("#CartExpress"); if(!wrap) return;
    var sig = cart.items.map(function(i){ return i.key + ":" + i.quantity + ":" + (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan ? i.selling_plan_allocation.selling_plan.id : 0); }).join("|") + "|" + cart.currency + "|" + cart.total_price;
    if(wrap.getAttribute("data-express-sig") === sig && wrap.firstChild) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var mine = ++expressReq;
    fetch(root + "?sections=cart-express", { headers:{ "Accept":"application/json" }, credentials:"same-origin" })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        if(mine !== expressReq || !j || typeof j["cart-express"] !== "string") return;
        var tmp = document.createElement("div"); tmp.innerHTML = j["cart-express"];
        var inner = tmp.querySelector("[data-cart-express]");
        wrap.innerHTML = inner ? inner.outerHTML : "";
        wrap.setAttribute("data-express-sig", sig);
        runInjectedScripts(wrap);
        try{ if(window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init){ window.Shopify.PaymentButton.init(); } }catch(err){}
      })
      .catch(function(){ /* wallets are a bonus; the Checkout button always works */ });
  }

  function addToCart(id, qty, sellingPlan){
    var item = { id:id, quantity: qty || 1 };
    if(sellingPlan){ item.selling_plan = sellingPlan; }
    return enqueue(function(){ return cartPost(T.routes.cart_add + ".js", { items:[item] }, true).then(afterAdd); });
  }
  function changeLine(key, qty){
    return enqueue(function(){
        return cartPost(T.routes.cart_change + ".js", { id:key, quantity:qty }, true)
          .then(function(c){ return (c && Array.isArray(c.items)) ? commitCart(c) : mutated(); });
      })
      .catch(function(err){
        return refreshCart().catch(function(){ $$(".cart-line.is-updating").forEach(function(l){ l.classList.remove("is-updating"); }); })
          .then(function(){ cartError((err && err.description) || S("cart_error")); });
      });
  }

  function initCart(){
    drawer.el = $("#CartDrawer"); drawer.scrim = $("#CartScrim");
    document.addEventListener("click", function(e){
      if(!e.target.closest) return;
      var openBtn = e.target.closest("[data-cart-open]");
      if(openBtn){
        if(cartPageEl()) return;                   // let a plain link behave normally on the cart page
        e.preventDefault(); openCart(); return;
      }
      var shop = e.target.closest("[data-cart-shop]");
      if(shop){
        // already on the page the button points to: just close the drawer
        var a = document.createElement("a"); a.href = shop.getAttribute("href") || "";
        if(a.pathname === window.location.pathname){ e.preventDefault(); }
        closeCart(); return;
      }
      if(e.target.closest("[data-cart-close]") || (drawer.scrim && e.target === drawer.scrim)){ closeCart(); return; }
      var add = e.target.closest("[data-add-variant]");
      if(add){
        e.preventDefault();
        if(add.getAttribute("aria-busy") === "true") return;
        var vid = add.getAttribute("data-add-variant"); if(!vid) return;
        var inDrawer = !!(drawer.el && drawer.el.contains(add));
        var host = inDrawer ? null : (add.closest(".prod-card, [data-quick-add-scope]") || null);
        setBusy(add, true); drawer.el && drawer.el.classList.add("is-loading");
        if(host) clearError(host);
        addToCart(vid, 1)
          .then(function(){ openCart(); })
          .catch(function(err){
            var msg = (err && err.description) || S("add_error");
            if(inDrawer){ cartError(msg); } else if(host){ showError(host, null, msg); }
          })
          .then(function(){ setBusy(add, false); drawer.el && drawer.el.classList.remove("is-loading"); });
        return;
      }
      var line = e.target.closest(".cart-line[data-key]");
      if(line){
        var key = line.getAttribute("data-key");
        var span = line.querySelector(".qty span");
        var q = parseInt(span ? span.textContent : "1", 10); if(isNaN(q)) q = 1;
        var next = null;
        if(e.target.closest("[data-qty-up]")){ next = q + 1; }
        else if(e.target.closest("[data-qty-down]")){ next = q - 1; }
        else if(e.target.closest("[data-remove]")){ next = 0; }
        if(next !== null && key){ e.preventDefault(); line.classList.add("is-updating"); changeLine(key, Math.max(0, next)); }
      }
    });
    document.addEventListener("keydown", function(e){
      if(!isOpen()) return;
      if(e.key === "Escape" || e.key === "Esc"){ closeCart(); return; }
      if(e.key === "Tab"){
        var f = drawerFocusables(); if(!f.length){ e.preventDefault(); return; }
        var first = f[0], last = f[f.length - 1], active = document.activeElement;
        if(!drawer.el.contains(active)){ e.preventDefault(); first.focus(); }
        else if(e.shiftKey && (active === first || active === drawer.el)){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && active === last){ e.preventDefault(); first.focus(); }
      }
    });
    // Other scripts (bundle / upsell apps) can ask the theme to re-read the cart.
    document.addEventListener("cart:refresh", function(){
      refreshCart().then(syncCartPage).catch(function(){});
    });
    T.cart = { refresh: refreshCart, open: openCart, close: closeCart };
    refreshCart().catch(function(){});
  }

  /* ---------- Quantity steppers: [data-qty] > [data-qty-minus] input [data-qty-plus] (delegated, min 1) ---------- */
  function qtyBounds(input){
    var min = parseInt(input.getAttribute("min"), 10); if(isNaN(min) || min < 1) min = 1;
    var max = parseInt(input.getAttribute("max"), 10); if(isNaN(max) || max < min) max = Infinity;
    var step = parseInt(input.getAttribute("step"), 10); if(isNaN(step) || step < 1) step = 1;
    return { min:min, max:max, step:step };
  }
  function initQty(){
    document.addEventListener("click", function(e){
      if(!e.target.closest) return;
      var btn = e.target.closest("[data-qty-minus], [data-qty-plus]"); if(!btn) return;
      var wrap = btn.closest("[data-qty]"); if(!wrap) return;
      var input = wrap.querySelector("input"); if(!input) return;
      e.preventDefault();
      var b = qtyBounds(input);
      var v = parseInt(input.value, 10); if(isNaN(v)) v = b.min;
      v += btn.hasAttribute("data-qty-plus") ? b.step : -b.step;
      v = Math.min(b.max, Math.max(b.min, v));
      if(String(v) !== input.value){
        input.value = v;
        input.dispatchEvent(new Event("input", { bubbles:true }));
        input.dispatchEvent(new Event("change", { bubbles:true }));
      }
    });
    document.addEventListener("change", function(e){
      var input = e.target;
      if(!input || !input.closest || input.tagName !== "INPUT" || !input.closest("[data-qty]")) return;
      var b = qtyBounds(input);
      var v = parseInt(input.value, 10); if(isNaN(v)) v = b.min;
      v = Math.min(b.max, Math.max(b.min, v));
      if(String(v) !== input.value) input.value = v;
    });
  }

  /* ---------- Product forms (PDP + hero): submit the WHOLE form so bundle / subscription
     app fields are included, like standard themes ---------- */
  function productFormData(form){
    var fd = new FormData(form);
    // Quantity: an app-injected [name=quantity] (anything without data-theme-qty) wins over the theme stepper.
    var appQty = null, themeQty = null;
    Array.prototype.slice.call(form.elements || []).forEach(function(el){
      if(!el || el.name !== "quantity" || el.disabled) return;
      if((el.type === "radio" || el.type === "checkbox") && !el.checked) return;
      var v = parseInt(el.value, 10);
      if(!(v >= 1)) return;
      if(el.hasAttribute("data-theme-qty")){ themeQty = v; } else { appQty = v; }
    });
    if(appQty !== null){ fd.set("quantity", String(appQty)); }
    else if(fd.has("quantity")){ fd.set("quantity", String(themeQty !== null ? themeQty : 1)); }
    // Selling plan: drop only EMPTY entries; a plan set by the theme or an app is always kept.
    if(fd.has("selling_plan")){
      var plans = fd.getAll("selling_plan").filter(function(p){ return p !== null && String(p).replace(/\s+/g, "") !== ""; });
      fd.delete("selling_plan");
      if(plans.length){ fd.set("selling_plan", String(plans[plans.length - 1])); }
    }
    return fd;
  }
  function addFormToCart(form){
    var fd = productFormData(form);                       // snapshot now, post when the queue reaches it
    return enqueue(function(){ return cartPost(T.routes.cart_add + ".js", fd).then(afterAdd); });
  }
  function formBusy(form, btn, on){
    if(on){ form.setAttribute("data-busy", "1"); } else { form.removeAttribute("data-busy"); }
    setBusy(btn, on);
    if(form.id === "ProductForm"){ $$("[data-sticky-add]").forEach(function(b){ setBusy(b, on); }); }
  }

  function initProductForm(){
    $$("#ProductForm, form.js-ajax-form").forEach(function(form){
      if(form.dataset.submitBound) return;
      form.dataset.submitBound = "1";
      form.addEventListener("submit", function(e){
        e.preventDefault();
        if(form.getAttribute("data-busy") === "1") return;
        var btn = form.querySelector('[type="submit"]');
        var idInput = form.querySelector('[name="id"]');
        if(idInput && !idInput.value) return;
        clearError(form);
        formBusy(form, btn, true);
        drawer.el && drawer.el.classList.add("is-loading");
        addFormToCart(form)
          .then(function(){ openCart(); })                       // success only: drawer (or cart page)
          .catch(function(err){ showError(form, btn, (err && err.description) || S("add_error")); })
          .then(function(){
            formBusy(form, btn, false);
            drawer.el && drawer.el.classList.remove("is-loading");
          });
      });
    });
  }

  /* ---------- Buy now: add the current form (same quantity / plan rules), then go to checkout ---------- */
  function expressVisible(wrap){
    var ex = wrap.querySelector("[data-express]"); if(!ex) return false;
    var btn = ex.querySelector(".shopify-payment-button__button, .shopify-payment-button button, .shopify-payment-button");
    if(!btn) return false;
    var cs = getComputedStyle(btn); if(cs.display === "none" || cs.visibility === "hidden") return false;
    var r = btn.getBoundingClientRect(); return r.height > 8;
  }
  function syncBuyNow(){
    $$("[data-buy-now-wrap]").forEach(function(wrap){
      var theme = wrap.querySelector("[data-buy-now]"), note = wrap.querySelector(".buy-stack__secure");
      if(!theme) return;
      var showTheme = !expressVisible(wrap);
      theme.style.display = showTheme ? "" : "none";
      if(note) note.style.display = showTheme ? "" : "none";
    });
  }
  function initBuyNow(){
    if(!$("[data-buy-now-wrap], [data-buy-now]")) return;
    // keep theme Buy now and Shopify express mutually exclusive, re-checking as apps show/hide the express button
    if(!window.__bbBuyNowSync){
      window.__bbBuyNowSync = true;
      var t; var kick = function(){ clearTimeout(t); t = setTimeout(syncBuyNow, 60); };
      kick(); setTimeout(syncBuyNow, 600); setTimeout(syncBuyNow, 1500); setTimeout(syncBuyNow, 3000);
      if("MutationObserver" in window){
        $$("[data-buy-now-wrap]").forEach(function(w){ new MutationObserver(kick).observe(w, { childList:true, subtree:true, attributes:true, attributeFilter:["style","class","hidden"] }); });
      }
      document.addEventListener("change", kick, true);
      document.addEventListener("click", kick, true);
      window.addEventListener("resize", kick);
    }
    $$("[data-buy-now]").forEach(function(btn){
      if(btn.dataset.bound) return; btn.dataset.bound = "1";
      btn.addEventListener("click", function(e){
        e.preventDefault();
        var form = btn.closest("form") || (btn.getAttribute("form") ? document.getElementById(btn.getAttribute("form")) : null);
        if(!form || form.getAttribute("data-busy") === "1") return;
        var idInput = form.querySelector('[name="id"]');
        if(idInput && !idInput.value) return;
        clearError(form);
        form.setAttribute("data-busy", "1"); setBusy(btn, true);
        cartPost(T.routes.cart_add + ".js", productFormData(form))
          .then(function(){ window.location.href = T.routes.checkout; })
          .catch(function(err){
            form.removeAttribute("data-busy"); setBusy(btn, false);
            showError(form, form.querySelector('[type="submit"]') || btn, (err && err.description) || S("add_error"));
            refreshCart().catch(function(){});
          });
      });
    });
  }

  /* ---------- Product buy box (variants + optional offer / plan radios) ---------- */
  function initProductBuy(){
    $$("[data-product-root]").forEach(function(root){
      var form = $("#ProductForm", root);
      if(!form || form.dataset.bound) return; form.dataset.bound = "1";
      var data; try{ data = JSON.parse($("[data-variant-json]", root).textContent); }catch(err){ data = null; }
      if(!data || !Array.isArray(data.variants)) data = { variants:[] };
      var idInput = $("[name=id]", form);
      var planInput = $("[data-selling-plan-input]", form);
      var picker = $("[data-variant-picker]", root);
      var subs = $("[data-subs]", root);
      var submit = $("[type=submit]", form);
      var addLabel = (submit && submit.getAttribute("data-add-label")) || S("add_to_cart");

      var state = {
        offer: "single",
        bundleVariant: null, bundlePrice: 0, bundleCompare: 0,
        singleVariant: (idInput && idInput.value) || (data.variants[0] && data.variants[0].id),
        plan: ""
      };

      function single(){ return data.variants.filter(function(v){ return String(v.id) === String(state.singleVariant); })[0] || data.variants[0] || null; }

      function apply(){
        var price, compare, available = true, variantId;
        if(state.offer === "bundle"){
          variantId = state.bundleVariant; price = state.bundlePrice; compare = state.bundleCompare;
        } else {
          var v = single();
          if(!v) return;                                // no variant data: leave the server-rendered form alone
          variantId = v.id; compare = v.compare_at_price; available = v.available !== false;
          if(state.plan){
            var pEl = $('[name=bb-plan][data-plan="' + state.plan + '"]', root);
            price = pEl ? parseInt(pEl.getAttribute("data-price"), 10) : v.price;
          } else { price = v.price; }
        }
        if(idInput && variantId != null) idInput.value = variantId;
        if(planInput) planInput.value = (state.offer === "single") ? state.plan : "";
        $$("[data-price-now]", root).forEach(function(n){ n.textContent = formatMoney(price); });
        var wasEl = $("[data-price-was]", root);
        if(wasEl){ if(compare && compare > price){ wasEl.textContent = formatMoney(compare); wasEl.style.display=""; } else { wasEl.style.display="none"; } }
        $$("[data-atc-price]", root).forEach(function(n){ n.textContent = formatMoney(price); });
        if(submit){
          var lbl = submit.querySelector("[data-atc-label]");
          if(available){ submit.removeAttribute("disabled"); if(lbl && addLabel) lbl.textContent = addLabel; }
          else { submit.setAttribute("disabled","true"); if(lbl && S("sold_out")) lbl.textContent = S("sold_out"); }
        }
        $$("[data-sticky-add]", root).forEach(function(b){
          var l = b.querySelector("[data-atc-label]");
          if(available){ b.removeAttribute("disabled"); if(l && addLabel) l.textContent = addLabel; }
          else { b.setAttribute("disabled","true"); if(l && S("sold_out")) l.textContent = S("sold_out"); }
        });
        if(picker) picker.style.display = (state.offer === "bundle") ? "none" : "";
        if(subs) subs.style.display = (state.offer === "bundle") ? "none" : "";
      }

      if(picker){
        picker.addEventListener("click", function(e){
          var opt = e.target.closest(".variant-opt"); if(!opt) return;
          var group = opt.closest("[data-option-index]"); if(!group) return;
          $$(".variant-opt", group).forEach(function(o){ o.classList.remove("active"); });
          opt.classList.add("active");
          var vals = $$(".variant-opt.active", picker).map(function(o){ return o.getAttribute("data-value"); });
          var v = data.variants.filter(function(vv){ return (vv.options || []).join("~~~") === vals.join("~~~"); })[0];
          if(v){
            state.singleVariant = v.id;
            var so = $('[name=bb-offer][data-offer-type="single"]', root);
            if(so){ so.setAttribute("data-variant", v.id); so.setAttribute("data-price", v.price); }
          }
          apply();
        });
      }

      $$('[name=bb-offer]', root).forEach(function(r){
        r.addEventListener("change", function(){
          state.offer = r.getAttribute("data-offer-type");
          if(state.offer === "bundle"){
            state.bundleVariant = r.getAttribute("data-variant");
            state.bundlePrice = parseInt(r.getAttribute("data-price"), 10);
            state.bundleCompare = parseInt(r.getAttribute("data-compare"), 10) || 0;
          }
          $$(".pdp-offer", root).forEach(function(l){ l.classList.remove("is-active"); });
          var lab = r.closest(".pdp-offer"); if(lab) lab.classList.add("is-active");
          apply();
        });
      });

      $$('[name=bb-plan]', root).forEach(function(r){
        r.addEventListener("change", function(){
          state.plan = r.getAttribute("data-plan") || "";
          $$(".pdp-sub", root).forEach(function(l){ l.classList.remove("is-active"); });
          var lab = r.closest(".pdp-sub"); if(lab) lab.classList.add("is-active");
          apply();
        });
      });

      apply();
    });
  }

  /* ---------- Lightbox (tap to expand media) ---------- */
  var lightboxEl = null;
  function openLightbox(slides, start, onNav){
    if(!slides.length) return;
    if(!lightboxEl){
      lightboxEl = document.createElement("div");
      lightboxEl.className = "lightbox";
      lightboxEl.setAttribute("role", "dialog"); lightboxEl.setAttribute("aria-modal", "true");
      lightboxEl.innerHTML = '<button class="lightbox__close" type="button" aria-label="' + escapeHtml(S("close")) + '">' + icon("close") + '</button>' +
        '<button class="lightbox__nav lightbox__nav--prev" type="button" aria-label="' + escapeHtml(S("previous")) + '">' + icon("arrow") + '</button>' +
        '<div class="lightbox__stage"></div>' +
        '<button class="lightbox__nav lightbox__nav--next" type="button" aria-label="' + escapeHtml(S("next")) + '">' + icon("arrow") + '</button>' +
        '<div class="lightbox__count"></div>';
      document.body.appendChild(lightboxEl);
      lightboxEl.addEventListener("click", function(e){
        if(e.target.closest(".lightbox__close")){ lightboxEl._close(); return; }
        if(e.target.closest(".lightbox__nav--prev")){ lightboxEl._nav(-1); return; }
        if(e.target.closest(".lightbox__nav--next")){ lightboxEl._nav(1); return; }
        if(e.target === lightboxEl){ lightboxEl._close(); }
      });
      var tx = 0, ty = 0;
      lightboxEl.addEventListener("touchstart", function(e){ if(e.touches[0]){ tx = e.touches[0].clientX; ty = e.touches[0].clientY; } }, { passive:true });
      lightboxEl.addEventListener("touchend", function(e){
        var t = e.changedTouches[0]; if(!t) return;
        var dx = t.clientX - tx, dy = t.clientY - ty;
        if(Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4){ lightboxEl._nav(dx < 0 ? 1 : -1); }
      }, { passive:true });
    }
    var stage = $(".lightbox__stage", lightboxEl);
    var count = $(".lightbox__count", lightboxEl);
    var cur = start;
    var opener = document.activeElement;
    function render(){
      stage.innerHTML = slides[cur].innerHTML;
      $$("img", stage).forEach(function(im){ im.removeAttribute("sizes"); im.removeAttribute("loading"); });
      count.textContent = (cur + 1) + " / " + slides.length;
      if(onNav) onNav(cur);
    }
    function nav(d){ cur = (cur + d + slides.length) % slides.length; render(); }
    function onKey(e){
      if(e.key === "Escape") close();
      if(e.key === "ArrowRight") nav(1);
      if(e.key === "ArrowLeft") nav(-1);
    }
    function close(){
      lightboxEl.classList.remove("show");
      stage.innerHTML = "";
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKey);
      if(opener && opener.focus && document.contains(opener)){ try{ opener.focus({ preventScroll:true }); }catch(err){} }
    }
    lightboxEl._nav = nav;
    lightboxEl._close = close;
    document.addEventListener("keydown", onKey);
    lightboxEl.classList.add("show");
    document.body.style.overflow = "hidden";
    render();
    var closeBtn = $(".lightbox__close", lightboxEl);
    if(closeBtn){ try{ closeBtn.focus({ preventScroll:true }); }catch(err){} }
  }

  /* ---------- PDP gallery (media slides: images + video) ---------- */
  function initGallery(){
    $$("[data-gallery]").forEach(function(g){
      if(g.dataset.bound) return; g.dataset.bound = "1";
      var main = $(".pdp-gallery__main", g);
      if(!main) return;
      var slides = $$(".pdp-slide", main);
      var thumbs = $$(".pdp-thumb", g);
      if(!slides.length) return;
      var i = 0;
      function show(n){
        i = (n + slides.length) % slides.length;
        slides.forEach(function(s, k){
          s.classList.toggle("active", k === i);
          if(k !== i){ $$("video", s).forEach(function(v){ v.pause(); }); }
        });
        thumbs.forEach(function(t, k){ t.classList.toggle("active", k === i); });
      }
      thumbs.forEach(function(t, k){ t.addEventListener("click", function(){ show(k); }); });
      var prev = $(".pdp-gallery__nav--prev", g), next = $(".pdp-gallery__nav--next", g);
      prev && prev.addEventListener("click", function(e){ e.stopPropagation(); show(i - 1); });
      next && next.addEventListener("click", function(e){ e.stopPropagation(); show(i + 1); });
      // swipe between media on touch
      var sx = 0, sy = 0;
      main.addEventListener("touchstart", function(e){ if(e.touches[0]){ sx = e.touches[0].clientX; sy = e.touches[0].clientY; } }, { passive:true });
      main.addEventListener("touchend", function(e){
        var t = e.changedTouches[0]; if(!t) return;
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if(Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4){ if(dx < 0){ show(i + 1); } else { show(i - 1); } }
      }, { passive:true });
      // tap to expand (skip video controls and nav arrows)
      main.addEventListener("click", function(e){
        if(e.target.closest(".pdp-gallery__nav")) return;
        if(e.target.closest("video, iframe")) return;
        openLightbox(slides, i, function(n){ show(n); });
      });
      show(0);
    });
  }

  /* ---------- Mobile swipe scrollers with dots ---------- */
  function initMobileScrollers(){
    $$(".ritual-steps, .treats-grid, #theory .g3, .compare-grid").forEach(function(grid){
      if(grid.dataset.carousel) return; grid.dataset.carousel = "1";
      var cards = Array.prototype.slice.call(grid.children).filter(function(c){ return c.nodeType === 1; });
      if(cards.length < 2 || !grid.parentNode) return;
      var dots = document.createElement("div"); dots.className = "results-dots";
      cards.forEach(function(_, i){
        var d = document.createElement("button"); d.type = "button"; d.className = "results-dot";
        d.setAttribute("aria-label", S("go_to_item") ? fill(S("go_to_item"), { n: i + 1 }) : String(i + 1));
        d.addEventListener("click", function(){ cards[i].scrollIntoView({ behavior:"smooth", inline:"center", block:"nearest" }); });
        dots.appendChild(d);
      });
      grid.parentNode.insertBefore(dots, grid.nextSibling);
      function update(){
        if(grid.scrollWidth <= grid.clientWidth + 4){ dots.style.display = "none"; return; }
        dots.style.display = "flex";
        var box = grid.getBoundingClientRect(), center = box.left + box.width / 2, best = 0, bd = 1e9;
        cards.forEach(function(c, i){ var r = c.getBoundingClientRect(), cc = r.left + r.width / 2, dd = Math.abs(cc - center); if(dd < bd){ bd = dd; best = i; } });
        $$(".results-dot", dots).forEach(function(d, i){ d.classList.toggle("active", i === best); });
      }
      grid.addEventListener("scroll", update, { passive:true });
      window.addEventListener("resize", update);
      update();

      // mouse / pen drag-to-scroll (touch already scrolls natively)
      var isDown = false, moved = false, startX = 0, startLeft = 0;
      function release(e){
        if(!isDown) return;
        isDown = false;
        grid.classList.remove("is-dragging");
        try{ grid.releasePointerCapture(e.pointerId); }catch(err){}
      }
      grid.addEventListener("pointerdown", function(e){
        if(e.pointerType === "touch") return;
        if(grid.scrollWidth <= grid.clientWidth + 4) return;
        isDown = true; moved = false; startX = e.clientX; startLeft = grid.scrollLeft;
        grid.classList.add("is-dragging");
        try{ grid.setPointerCapture(e.pointerId); }catch(err){}
      });
      grid.addEventListener("pointermove", function(e){
        if(!isDown) return;
        var dx = e.clientX - startX;
        if(Math.abs(dx) > 6) moved = true;
        grid.scrollLeft = startLeft - dx;
      });
      grid.addEventListener("pointerup", release);
      grid.addEventListener("pointercancel", release);
      grid.addEventListener("click", function(e){
        if(moved){ e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
    });
  }

  /* ---------- Region / currency picker ---------- */
  function initRegion(){
    $$("[data-region-select]").forEach(function(sel){
      if(sel.dataset.bound) return; sel.dataset.bound = "1";
      sel.addEventListener("change", function(){ var f = sel.closest("form"); if(f){ f.submit(); } });
    });
  }

  /* ---------- Sticky ATC: owns no inputs, always submits #ProductForm ---------- */
  function initStickyAtc(){
    var bar = $("#StickyAtc"); var watch = $("#ProductBuyBox");
    if(!bar || !watch) return;
    if(!bar.dataset.scrollBound){
      bar.dataset.scrollBound = "1";
      var on = function(){
        var r = watch.getBoundingClientRect(), show = r.bottom < 60;
        bar.classList.toggle("show", show);
        bar.setAttribute("aria-hidden", show ? "false" : "true");
      };
      on(); window.addEventListener("scroll", on, { passive:true });
    }
    var btn = $("[data-sticky-add]", bar);
    if(btn && !btn.dataset.bound){
      btn.dataset.bound = "1";
      btn.addEventListener("click", function(){
        var f = $("#ProductForm");
        if(!f) return;
        var sb = f.querySelector('[type="submit"]');
        if(sb && sb.disabled) return;                       // sold out: follow the main button, never post
        if(f.requestSubmit){ f.requestSubmit(); }
        else { f.dispatchEvent(new Event("submit", { cancelable:true, bubbles:true })); }
      });
    }
  }

  /* ---------- Hero media: thumbs + arrows + swipe + keys ---------- */
  function initHeroThumbs(){
    $$(".hero__media").forEach(function(mediaWrap){
      if(mediaWrap.dataset.bound) return;
      var main = mediaWrap.querySelector("[data-hero-slides]"); if(!main) return;
      var slides = $$(".pdp-slide", main); if(!slides.length) return;
      mediaWrap.dataset.bound = "1";
      var wrap = mediaWrap.querySelector("[data-hero-thumbs]");
      var thumbs = wrap ? $$(".hero__thumb", wrap) : [];
      var i = 0;
      slides.forEach(function(s, k){ if(s.classList.contains("active") && i === 0) i = k; });
      function show(n){
        i = (n + slides.length) % slides.length;
        slides.forEach(function(s,k){ s.classList.toggle("active", k===i); if(k!==i){ $$("video", s).forEach(function(v){ v.pause(); }); } });
        thumbs.forEach(function(t,k){ t.classList.toggle("active", k===i); });
        if(thumbs[i] && thumbs[i].scrollIntoView){ thumbs[i].scrollIntoView({ behavior:"smooth", inline:"center", block:"nearest" }); }
        mediaWrap.classList.toggle("is-browsing", i > 0);
      }
      if(wrap){ wrap.addEventListener("click", function(e){ var b=e.target.closest(".hero__thumb"); if(!b) return; var k=thumbs.indexOf(b); if(k>-1) show(k); }); }
      var prev = mediaWrap.querySelector("[data-hero-prev]"), next = mediaWrap.querySelector("[data-hero-next]");
      prev && prev.addEventListener("click", function(e){ e.preventDefault(); e.stopPropagation(); show(i-1); });
      next && next.addEventListener("click", function(e){ e.preventDefault(); e.stopPropagation(); show(i+1); });
      // swipe
      var sx=0, sy=0;
      main.addEventListener("touchstart", function(e){ if(e.touches[0]){ sx=e.touches[0].clientX; sy=e.touches[0].clientY; } }, { passive:true });
      main.addEventListener("touchend", function(e){ var t=e.changedTouches[0]; if(!t) return; var dx=t.clientX-sx, dy=t.clientY-sy; if(Math.abs(dx)>44 && Math.abs(dx)>Math.abs(dy)*1.4){ show(dx<0 ? i+1 : i-1); } }, { passive:true });
      // keyboard when the media is focused
      main.setAttribute("tabindex","0");
      main.addEventListener("keydown", function(e){ if(e.key==="ArrowRight"){ show(i+1); } if(e.key==="ArrowLeft"){ show(i-1); } });
    });
  }

  /* ---------- App-block wrappers (sections/apps.liquid): drop the band padding while the app block
     has no rendered height (plan lapsed, script blocked, not loaded yet). The element stays in flow so a
     lazy-loading widget still sees its width and the observers fire once it fills in. ---------- */
  function initAppsSections(){
    if(window.Shopify && window.Shopify.designMode) return;  // the editor always shows the slot
    $$(".apps-section").forEach(function(sec){
      if(sec.dataset.emptyBound) return;
      var blocks = $$(".shopify-block, .shopify-app-block", sec);
      if(!blocks.length) return;
      sec.dataset.emptyBound = "1";
      var check = function(){
        var h = 0; blocks.forEach(function(b){ h += b.getBoundingClientRect().height; });
        sec.classList.toggle("apps-section--empty", h < 4);
      };
      check();
      if("ResizeObserver" in window){ var ro = new ResizeObserver(check); blocks.forEach(function(b){ ro.observe(b); }); }
      if("MutationObserver" in window){ new MutationObserver(check).observe(sec, { childList:true, subtree:true }); }
      window.addEventListener("load", check);
    });
  }

  /* ---------- Count up ---------- */
  var countIo = null;
  function initCountUp(){
    // The real value is already in the HTML. Only animate when we can, from 0 up to it,
    // and never leave the element blank or at 0 if anything goes wrong.
    if(!("IntersectionObserver" in window) || !("requestAnimationFrame" in window)) return;
    if(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var els = $$(".stat__val [data-count]").filter(function(el){ return !el.dataset.countBound; });
    if(!els.length) return;
    if(!countIo){
      countIo = new IntersectionObserver(function(ents){
        ents.forEach(function(e){
          if(!e.isIntersecting) return; countIo.unobserve(e.target);
          var el = e.target, to = parseFloat(el.getAttribute("data-count")), suf = el.getAttribute("data-suffix")||"";
          var finalText = el.textContent;
          if(isNaN(to)) return;
          var start = performance.now(), dur = 1400;
          function tick(now){
            var p = Math.min(1,(now-start)/dur), eased = 1-Math.pow(1-p,3);
            el.textContent = Math.round(to*eased).toLocaleString() + suf;
            if(p<1) requestAnimationFrame(tick); else el.textContent = finalText;
          }
          requestAnimationFrame(tick);
        });
      }, { threshold:.4 });
    }
    els.forEach(function(el){ el.dataset.countBound = "1"; countIo.observe(el); });
  }

  /* ---------- helpers ---------- */
  function escapeHtml(s){ return String(s == null ? "" : s).replace(/[&<>"']/g, function(c){ return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"}[c]; }); }
  function icon(name){
    var I = {
      bag:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M6 8h12l1 12H5L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
      plus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true" focusable="false"><path d="M12 5v14M5 12h14"/></svg>',
      minus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true" focusable="false"><path d="M5 12h14"/></svg>',
      close:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6 6 18"/></svg>',
      arrow:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true" focusable="false"><path d="M5 12h14M13 6l6 6-6 6"/></svg>'
    };
    return I[name]||"";
  }

  /* ---------- init ---------- */
  function safe(fn){ try{ fn(); }catch(err){ if(window.console && console.warn){ console.warn(err); } } }
  function initSections(){
    [initReveal, initMobileScrollers, initGallery, initProductForm, initProductBuy, initStickyAtc, initCountUp, initHeroThumbs, initRegion, initCompareTabs, initCompareVideos, initBuyNow, initAppsSections].forEach(safe);
  }
  function init(){
    [initHeader, initMenu, initCart, initQty].forEach(safe);
    initSections();
    // re-run per-section setup after Shopify section reloads in the editor
    document.addEventListener("shopify:section:load", initSections);
  }
  if(document.readyState === "loading"){ document.addEventListener("DOMContentLoaded", init); } else { init(); }
})();
